import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { environment } from '@env/environment';
import { Observable } from 'rxjs';
import { IInHomeCareChange } from 'app/models/licenses/in-home-care/in-home-care-change';
import { IInHomeCareLicense } from 'app/models/licenses/in-home-care/in-home-care-license';

@Injectable({providedIn: 'root'})
export class InHomeCareChangeService {
  public api: string = environment.privateApi + 'InHomeCareChange/';
  public licenseApi: string = environment.privateApi + 'InHomeCareLicense/';

  public http = inject(HttpClient);

  public createChange(change: IInHomeCareChange): Observable<IInHomeCareChange>{
    return this.http.post<IInHomeCareChange>(this.api + 'CreateChange', change);
  }

  public getChanges(licenseId: number): Observable<IInHomeCareChange[]>{
    return this.http.get<IInHomeCareChange[]>(this.api + 'GetChanges/' + licenseId);
  }

  public updateChange(change: IInHomeCareChange): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'UpdateChange', change);
  }

  public submitChange(change: IInHomeCareChange): Observable<boolean>{
    return this.http.post<boolean>(this.api + 'SubmitChange', change);
  }

  public deleteChange(changeId: number): Observable<boolean>{
    return this.http.delete<boolean>(this.api + 'DeleteChange/' + changeId);
  }

  public getSubunits(licenseId: string): Observable<IInHomeCareLicense[]>{
    return this.http.get<IInHomeCareLicense[]>(this.licenseApi + 'GetSubunits/' + licenseId);
  }
}
